/**
 * Enum representing the types of individuals.
 * @readonly
 * @enum {string}
 */

export const TIPO_PESSOA = {
  FISICA: 'Pessoa Física',
  JURIDICA: 'Pessoa Jurídica',
};
